var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabHeader',{staticClass:"tab-links"},_vm._l((_vm.tabs),function(tab){return _c('TabHeaderLink',{key:tab.link,attrs:{"to":tab.link,"label":tab.label,"icon":tab.icon,"data-qa":tab.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }